import { useCallback, useEffect, useState } from 'react'
import { CdsService, CdsServiceSpec, HeaderItem } from './cds.types'
import { Actions, useAdministrationStateContext, useStickyState } from '../../components/state'

export function CdsServicesState() {
    const { globalState: state, dispatch } = useAdministrationStateContext()

    const [cdsServices, setCdsServices] = useStickyState([] as CdsService[], 'cdsServices')
    const [loaded, setLoaded] = useState(false)

    const RehydrateServices = useCallback(() => {
        async function rehydrate() {
            const updatedServices = [...cdsServices]
            for (const service of updatedServices as CdsService[]) {
                if (service.prefetch === null) {
                    try {
                        const results = await http<CdsServiceSpec>(service.url, service.headers)
                        const result = results.services.filter(result => result.id === service.id)

                        if (result.length > 0) {
                            service.prefetch = result[0].prefetch
                            const index = updatedServices.indexOf(service)
                            updatedServices[index] = service
                        }
                    } catch(error: any) {
                        dispatch(Actions.AddError({ 
                            message: `Error occured while loading ${service.url}`,
                            stacktrace: [
                                error.message, 
                                '\nPlease check CDS Services panel'
                            ]
                        }))
                    }
                }
            }
            dispatch(Actions.SetCdsServices(updatedServices))
            dispatch(Actions.SetServicesLoaded(true))
            setLoaded(true)
        }

        if (cdsServices && cdsServices !== null) {
            rehydrate()
        }

    }, [cdsServices, dispatch])

    useEffect(() => {
        if (!loaded) {
            RehydrateServices()
        }
    }, [RehydrateServices, loaded])

    const SaveChanges = useCallback(() => {
        const updatedServicesForCache = [] as CdsService[]
        for (const service of state.cdsServices) {
            const clone = { ...service }
            clone.prefetch = null
            clone.populatedPrefetch = null
            updatedServicesForCache.push(clone);
        }

        setCdsServices(updatedServicesForCache)
    }, [state.cdsServices, setCdsServices])

    useEffect(() => {
        if (loaded) {
            SaveChanges()
        }
    }, [SaveChanges, loaded])

    async function http<T>(
        url: string,
        headerData: HeaderItem[]
    ): Promise<T> {
        const headers = new Headers({ 'Content-Type': 'application/json' })
        headerData.forEach(headerItem => {
            headers.append(headerItem.key, headerItem.value);
        })
        const response = await fetch(url, {
            method: 'GET',
            headers: headers,
        })
        const responseBody = await response.json()

        return responseBody
    }
}